import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { formatDate } from "@angular/common";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TenderService {
  private tenderKey = 'tenderData'; // Key for localStorage
  // private apiUrl = 'https://210.56.11.150:8243/configurationmanagement/globalsettings/1.0.0/api/v1/globalsettings/';
  // private attachmentUrl = 'https://210.56.11.150:8243/documentmanagementsystem/dms/1.0.0/api/v1/dms/uploadfilebypass';
  private apiUrl = 'https://apiprd.eprocure.gov.pk/configurationmanagement/globalsettings/1.0.0/api/v1/globalsettings/';
  private attachmentUrl = 'https://apiprd.eprocure.gov.pk/documentmanagementsystem/dms/1.0.0/api/v1/dms/uploadfilebypass';
  constructor(private http: HttpClient) { }

  setTenderData(tender: any) {
    debugger
    localStorage.setItem(this.tenderKey, JSON.stringify(tender)); // Store in localStorage
  }

  getTenderData() {
    return JSON.parse(localStorage.getItem(this.tenderKey) || 'null'); // Retrieve from localStorage
  }

  clearTenderData() {
    localStorage.removeItem(this.tenderKey); // Remove data when needed
  }

  getTenderInfo(r: any): Observable<any> {
    const headers = new HttpHeaders({
      'aaa-log': 'dXNlcj10ZXN0YWRtaW4xfCB0aW1lPTEwOjA0OjA5IEdNVCswNTAwIChQYWtpc3RhbiBTdGFuZGFyZCBUaW1lKQ==',
      'accept': 'application/json, text/plain, */*',
      'accept-language': 'en-US,en;q=0.9,mt;q=0.8',
      'access-control-allow-origin': '*',
      'Authorization': 'Basic YWRtaW46cHByYTEy',
      'content-type': 'application/json',
      'fui': 'DAAAAJYXZlmCVLrFHpzKuhAAAABMGN/pOjgKIKbkey3e2IHbmiy8pKJnHfC2ScdoHrqVeIyYdWEA5cNARiIBG6jClGaZS+EmuZyyB2LP7aUxpwwz+KYmDKf03g8ESNc4GdIT2GqViPUrmsOT',
      'officedetail': 'F-PPRA-Dev',
      'roleid': 'DAAAAIJwukGlgONGVCYffRAAAAAjeeyeVrTTODFfc763ecG27rMDRQDdnwm8F0EBBkdjn0vVf+15ag==',
      'sec-ch-ua': '"Chromium";v="134", "Not:A-Brand";v="24", "Google Chrome";v="134"',
      'sec-ch-ua-mobile': '?0',
      'sec-ch-ua-platform': '"Windows"',
      'sec-fetch-dest': 'empty',
      'sec-fetch-mode': 'cors',
      'sec-fetch-site': 'same-site',
      'sid': 'dXNlcj10ZXN0YWRtaW4xfCB0aW1lPTEwOjA0OjA5IEdNVCswNTAwIChQYWtpc3RhbiBTdGFuZGFyZCBUaW1lKQ==',
      'tid': 'MjAyNTAzMTkuMTA0NjQ5LjY4OA==',
      'userid': 'ed618399-e307-44e5-973c-4f75fdb24dd6'
    });

    const body = {
      loggedInUserID: r.userId,
      Userid: r.userId,
      loggedInUserOfficeID: '31603',
      ids: 0,
      pno: 0,
      paginationRequest: {
        topRecords: 1,
        pageNumber: '1',
        pageSize: '500',
        orderBy: '',
        orderByColumnName: ''
      }
    };

    return this.http.post(this.apiUrl + 'getlgtenderinfoportal', body, { headers });
  }

  insertUpdateTender(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'aaa-log': 'dXNlcj10ZXN0YWRtaW4xfCB0aW1lPTExOjMxOjI3IEdNVCswNTAwIChQYWtpc3RhbiBTdGFuZGFyZCBUaW1lKQ==',
      'accept': 'application/json, text/plain, */*',
      'accept-language': 'en-US,en;q=0.9,mt;q=0.8',
      'access-control-allow-origin': '*',
      'Authorization': 'Basic YWRtaW46cHByYTEy',
      'content-type': 'application/json',
      'fui': 'DAAAAOzwQ+A632rVauZcfhAAAAB1RjAcs5TjPggh81/fEd2P/vp1q7My2S1awFeX35qWRBTY1MF8WeUPQG2bBpiqSlt/X8uFF+F9b5E9+duypagSeFuTZeucNAzEsvYL9JR7woQQRm0Zx/my',
      'officedetail': 'F-PPRA-Dev',
      'roleid': 'DAAAANCi/7ghKa0YmDzQABAAAADokc1aysGoKC9WHSEmSuYw3CCd/bjJYl+b+mhyw82LNenCT3IQZQ==',
      'sec-ch-ua': '"Chromium";v="134", "Not:A-Brand";v="24", "Google Chrome";v="134"',
      'sec-ch-ua-mobile': '?0',
      'sec-ch-ua-platform': '"Windows"',
      'sec-fetch-dest': 'empty',
      'sec-fetch-mode': 'cors',
      'sec-fetch-site': 'same-site',
      'sid': 'dXNlcj10ZXN0YWRtaW4xfCB0aW1lPTExOjMxOjI3IEdNVCswNTAwIChQYWtpc3RhbiBTdGFuZGFyZCBUaW1lKQ==',
      'tid': 'MjAyNTAzMTkuMTIwMjIyLjg3Nw==',
      'userid': 'ed618399-e307-44e5-973c-4f75fdb24dd6'
    });

    return this.http.post(this.apiUrl + 'insertupdatedynamicreportsportal', payload, { headers });
  }

  getTenderType(): Observable<any> {
    const headers = new HttpHeaders({
      'accept': 'application/json, text/plain, */*',
      'accept-language': 'en-US,en;q=0.9,mt;q=0.8',
      'access-control-allow-origin': '*',
      'Authorization': 'Basic YWRtaW46cHByYTEy',

    });

    return this.http.post(this.apiUrl + 'getlgtypeportal', {}, { headers });
  }

  getSectorName(): Observable<any> {
    const headers = new HttpHeaders({
      'accept': 'application/json, text/plain, */*',
      'accept-language': 'en-US,en;q=0.9,mt;q=0.8',
      'access-control-allow-origin': '*',
      'Authorization': 'Basic YWRtaW46cHByYTEy',

    });

    return this.http.post(this.apiUrl + 'getlgsectorsportal', {}, { headers });
  }

  insertAttachment(fileModel: any): Observable<any> {
    const headers = new HttpHeaders({
      'aaa-log': 'dXNlcj10ZXN0YWRtaW4xfCB0aW1lPTExOjMxOjI3IEdNVCswNTAwIChQYWtpc3RhbiBTdGFuZGFyZCBUaW1lKQ==',
      'accept': 'application/json, text/plain, */*',
      'accept-language': 'en-US,en;q=0.9,mt;q=0.8',
      'access-control-allow-origin': '*',
      'Authorization': 'Basic YWRtaW46cHByYTEy',
    });

    var req = fileModel;
    return this.http.post(this.attachmentUrl, req, { headers });
  }



}
